var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPunchingBag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.25 2.75904C13.25 2.33983 12.9142 2 12.5 2C12.0858 2 11.75 2.33983 11.75 2.75904V3.88691C10.8909 4.16 10.2316 4.88981 10.05 5.79518H10C8.89543 5.79518 8 6.7014 8 7.81928V9.08434H17V7.81928C17 6.7014 16.1046 5.79518 15 5.79518H14.95C14.7684 4.88981 14.1091 4.16 13.25 3.88691V2.75904ZM12.5 5.28916C12.8701 5.28916 13.1933 5.49268 13.3662 5.79518H11.6338C11.8067 5.49268 12.1299 5.28916 12.5 5.28916Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 10.6024V12.1205H17V10.6024H8Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 13.6386V19.9759C8 21.0938 8.89543 22 10 22H15C16.1046 22 17 21.0938 17 19.9759V13.6386H8Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPunchingBag);
export default __webpack_public_path__ + "static/media/punching-bag.6f339f7ccb260f82be014c81bd810cbf.svg";
export { ForwardRef as ReactComponent };